export default __webpack_public_path__ + "static/p2_en-c43193cf918ce36080cbdf90f1a0cdb7.png";